import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { WebApiService } from 'src/app/shared';
import { OfferSection, Product } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class ProjectPreperationService extends WebApiService {
  private projectPreperationProductsUrl = `${this.catalogUrl}/projectpreperations`;
  private ppSectionUrl = 'projectpreperation';

  constructor(protected http: HttpClient, protected snackBar: MatSnackBar) {
    super(http, snackBar);
  }

  public getProjectPreperationProducts(): Observable<Product[]> {
    return this.http.get<any[]>(`${this.projectPreperationProductsUrl}`, { responseType: 'json' })
      .pipe(this.handleApiRequest());
  }

  public addProjectPreperationSection(pojectId: Guid, ppSection: OfferSection): Observable<OfferSection> {
    return this.http.post<OfferSection>(
      `${this.offersUrl}/${pojectId}/${this.ppSectionUrl}`, ppSection, { responseType: 'json' })
      .pipe(this.handleApiRequest());
  }

  public getProjectPreperationSection(pojectId: Guid): Observable<OfferSection> {
    return this.http.get<OfferSection>(`${this.offersUrl}/${pojectId}/${this.ppSectionUrl}`, { responseType: 'json' })
      .pipe(this.handleApiRequest());
  }

  public updateProjectPreperationSection(pojectId: Guid, ppSection: OfferSection): Observable<OfferSection> {
    return this.http.put<OfferSection>(`${this.offersUrl}/${pojectId}/${this.ppSectionUrl}`, ppSection, { responseType: 'json' })
      .pipe(this.handleApiRequest());
  }

  public deleteProjectPreperationSection(pojectId: Guid): Observable<OfferSection> {
    return this.http.delete<OfferSection>(`${this.offersUrl}/${pojectId}/${this.ppSectionUrl}`, { responseType: 'json' })
      .pipe(this.handleApiRequest());
  }
}
